/**
 * Reasoning effort as a chip.
 *
 * Lifted out of `pages/LlmUsagePage.tsx`, where it was declared inline, so that
 * the two surfaces that show routing — the admin LLM-usage panel and the live
 * parse-activity panel's technical tier — cannot drift into meaning different
 * things by the same swatch. An effort chip is one thing in this product; it
 * lives in one file.
 */

import React from 'react'

// Violet whenever the model was asked to reason, matching the reasoning-tokens
// column; `minimal` is the product's default and stays quiet. Null is its own
// bucket rather than missing data — no reasoning parameter was sent, which is
// every `llm_logs` row before 2026-09-12 and every Anthropic call, so it reads
// as "none" and not as a gap.
const EffortChip: React.FC<{ effort: string | null }> = ({ effort }) => {
  if (!effort) return <span className="text-gray-400" title="No reasoning parameter sent">none</span>
  const quiet = effort === 'minimal'
  return (
    <span
      className={`inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-medium ${
        quiet ? 'bg-gray-100 text-gray-600' : 'bg-violet-100 text-violet-900'
      }`}
    >
      {effort}
    </span>
  )
}

export default EffortChip
